import { z } from 'zod'

// 料金プランの計算ロジック識別子。Prisma の `PlanSlug` enum（schema.prisma が正本）と同じ値を持つ。
// 値を足したら schema.prisma・マイグレーション・calculateBillingService の switch・ここを揃えること。
export const planSlugSchema = z.enum([
  'legacy_count_v1',
  'standard_tonnage_v1',
  'toda_standard_v1',
  'zenitaka_count_v1',
  'alpha_count_v1',
  'plan_a_count_v1',
  'beta_count_v1',
  'shimizu_tonnage_v1',
  'obayashi_tonnage_2026',
  'light_tonnage_v1',
])
export type PlanSlug = z.infer<typeof planSlugSchema>

// ライトプラン（メタルタグ紐付けなし・鉄筋1トンあたり100円）の slug。
// 機能制限の判定にも使うため、文字列リテラルを各所に散らさず定数で参照する。
export const LIGHT_PLAN_SLUG = 'light_tonnage_v1' satisfies PlanSlug

// admin のプラン作成フォーム・プラン一覧で CS（ビジネス側）に見せる表示名。
// 「どの計算ロジックを選べばよいか」が名前だけで分かるよう、顧客名・プラン名で表す。
export const planSlugLabels: Record<PlanSlug, string> = {
  standard_tonnage_v1: 'スタンダード（トン数ベース・現行）',
  light_tonnage_v1: 'ライト（トン数ベース・メタルタグなし）',
  toda_standard_v1: '戸田建設 標準導入',
  shimizu_tonnage_v1: '清水建設（トン数ベース）',
  obayashi_tonnage_2026: '大林組 2026年度（トン数ベース）',
  zenitaka_count_v1: '錢高組（枚数ベース）',
  legacy_count_v1: '旧 枚数ベース',
  alpha_count_v1: '旧 枚数ベース α',
  plan_a_count_v1: '旧 枚数ベース A',
  beta_count_v1: '旧 枚数ベース β',
}

// 各 slug の料金の要点（税抜）。正本は calculators.ts の各計算器。ここは選択時の目安で、
// 金額を変えるときは calculators.ts と一緒に直す。
export const planSlugDescriptions: Record<PlanSlug, string> = {
  standard_tonnage_v1:
    'サーバー月額1,000円。鉄筋データ登録料は300トンまで80,000円、超過分1トンあたり+170円。納品書PDF 1トン80円、機械式継手1枚250円。',
  light_tonnage_v1:
    'サーバー月額1,000円。鉄筋データ登録料は1トンあたり100円（固定額なし）。納品書PDF 1トン80円、機械式継手1枚250円。メタルタグ紐付け・スマホアプリは利用不可。',
  toda_standard_v1:
    'サーバー月額800円。鉄筋データ登録料は300トンまで80,000円、以降1トンあたり+110円/+95円/+75円の段階制。納品書PDF 1トン30円。',
  shimizu_tonnage_v1:
    'サーバー月額1,000円。鉄筋データ登録料は300トンまで80,000円、以降1トンあたり+170円/+130円/+100円の段階制。納品書PDF 1トン80円。',
  obayashi_tonnage_2026:
    'サーバー月額850円。鉄筋データ登録料は300トンまで68,000円、超過分1トンあたり+170円。納品書PDF 1トン80円。',
  zenitaka_count_v1:
    'サーバー月額1,000円。鉄筋ラベル登録料は1,000枚まで50,000円、以降1枚あたり+50円/+25円の段階制。PDF 1枚200円。',
  legacy_count_v1:
    'サーバー月額1,000円。鉄筋ラベル登録料は500枚未満100,000円、1,000枚まで140,000円、以降1枚あたり+100円/+50円。PDF 1枚200円。',
  alpha_count_v1: 'サーバー月額8,000円。鉄筋ラベル登録料は1,000枚まで50,000円、以降1枚あたり+25円/+10円。PDF 1枚200円。',
  plan_a_count_v1: 'サーバー月額10,000円。鉄筋ラベル登録料は1,000枚まで50,000円、以降1枚あたり+25円/+10円。PDF 1枚200円。',
  beta_count_v1: 'サーバー月額9,000円。鉄筋ラベル登録料は1,000枚まで50,000円、以降1枚あたり+25円/+10円。PDF 1枚200円。',
}

// Select 用の選択肢。labels の宣言順（現行プランが上、旧プランが下）をそのまま表示順にする
export const planSlugOptions = (Object.keys(planSlugLabels) as PlanSlug[]).map((value) => ({
  value,
  label: planSlugLabels[value],
}))
